import React from 'react';
import { withNavigate } from '../../util/withNavigate';
import { QRCodeSVG } from 'qrcode.react';
import { connect } from 'react-redux';
const { filterPlaylist } = require('@blackdove/bd-app-package').functions;

import Artwork from '../FullScreenCarouselItem';
import SelectedPlaylistCarousel from '../SelectedPlaylistCarousel';
import Account from '../Account';
import Settings from '../Settings';

import SoundCloudPlayer from '../SoundCloudPlayer';
import { FETCH_MOBILE_STATUS_FAILURE } from '../../store/constants/mobileConstants';
import './freemium-full-screen-carousel.scss';
import '../Account/account.scss';

import { fireAnalytics } from '../../pages/utils';
import { fetchActivePlaylist } from '../../store/actions/playlistActions';
import { fetchMobileQueue, fetchMobileStatus } from '../../store/actions/mobileActions';
import { pauseSoundCloudStream, resumeSoundCloudStream } from '../../store/actions/soundCloudActions';
import {
  set4kQuality,
  setMute,
  setQR,
  setShowArtworkDetails,
  setSwitchArtwork,
  setShowLogo,
  setMatchContent,
  setFillScreen,
  setRandomise,
} from '../../store/actions/settingActions';
import { ENTER, BACK, LEFT, UP, RIGHT, DOWN } from '../../util/remoteButtons';
import bdReq from '../../network/bdReq';
import Download from '../../util/download';

export class FreemiumCarousel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      current: props.selectedArtwork,
      navTimeout: null,
      navigating: false,
      nxtLoad: false,
      others: false,
      artworks: props.artworks,
      show: true,
      activeComponent: false,
      currentPlaylist: 0,
      currentDownloads: 0,
      selectedPlaylistId: props.selectedPlaylistId,
      selectedPlaylist: null,
      open: false,
      lastMobileUpdate: null,
      userId: null,
      selectedButton: 'view',
      artworkError: false,
      clearCache: false,
      hideCollection: true,
      selectedMenu: 'account',
      openMenu: false,
      openAccount: false,
      openSettings: false,
      hideDetails: this.props.setting.showArtworkDetails,
      qr: this.props.setting.qr,
      quality: this.props.setting.highQuality,
      mute: this.props.setting.mute,
      logo: this.props.setting.logo,
      matchContent: this.props.setting.matchContent,
      fillScreen: this.props.setting.fillScreen,
      randomise: this.props.setting.randomise,
      navigation: false,
      mismatchPopup: false,
      openPlaylist: false,
      artworkErrorMessage: '',
      isPortrait: window.innerWidth <= window.innerHeight,
      styles: {},
      downloadedArtNames: [],
      closedSettings: false,
      selectedBtn: 'No',
    };
    this.fsTimeout = null;
    this.getCurrentArtworkArtistName = this.getCurrentArtworkArtistName.bind(this);
    this.getCurrentArtworkName = this.getCurrentArtworkName.bind(this);
    this.handleConnectionChange = this.handleConnectionChange.bind(this);
    this.setArtworkInterval = this.setArtworkInterval.bind(this);
    this.hideCollections = this.hideCollections.bind(this);
    this.handleUpdateDownloads = this.handleUpdateDownloads.bind(this);
    this.changeUpdatePlaylistStatus = this.changeUpdatePlaylistStatus.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.k = 1;
    this.artworkInterval = 300000;
    this.updatePlaylist = true;
    this.hideArtworkNameTimeout = null;
    this.onlineStatusInterval = null;
    this.artworkIntervalTime = null;
    this.onlineStatusTimer = 0;
    this.prevPlaylistId = '';
    this.fetchMobilePlaylistInterval = null;
    this.isPlaylistUpdated = false;
    this.navigationTimeout = null;
    this.download = new Download();
    this.activePlaylistId = screen.orientation.type === 'landscape-primary' ?
                      'Y0d4aGVXeHBjM1E9NzlmMzdkNzAtYTlmZC0xMWU3LWI5ZDMtNTU2OGIzMzVhMDUx' :
                      'b1f908bb-9722-4e70-ac5c-653ad45ee3ea'
  }

  filterByOrientation = (artworks) => {
    const { matchContent } = this.props.setting;
    if (!matchContent || !artworks?.length) return artworks;

    const isPortrait = screen.orientation.type !== 'landscape-primary';
    const filtered = artworks.filter((a) => {
      if (!a.sourceFile?.metadata) return true;
      const w = parseInt(a.sourceFile.metadata.width) || 0;
      const h = parseInt(a.sourceFile.metadata.height) || 0;
      if (w === 0 && h === 0) return true;
      const isArtworkLandscape = w > h;
      const isMismatch = isPortrait ? isArtworkLandscape : !isArtworkLandscape;
      return !isMismatch;
    });

    return filtered.length > 0 ? filtered : artworks;
  };

  componentDidMount() {
    fireAnalytics('Page', 'Player Page Loaded');
    const filtered = this.filterByOrientation(this.state.artworks);
    if (filtered !== this.state.artworks) {
      this.setState({ artworks: filtered, styles: this.getStyles() });
    } else {
      this.setState({ styles: this.getStyles() });
    }
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
    window.addEventListener("keydown",this.handleKeyDown);

    if (this.props.hasSubscription) {
      this.fetchMobilePlaylistInterval = setInterval(() => this.FetchFromMobile(), 5000);
    } else {
      this.fetchMobilePlaylistInterval = 10;
      this.setArtworkInterval(this.artworkInterval);
    }
    window.addEventListener('online', this.handleConnectionChange);
    window.addEventListener('offline', this.handleConnectionChange);

    if (!this.props.setting.showArtworkDetails) {
      this.setState({
        hideDetails: true,
      });
    } else {
      this.setState({
        hideDetails: false,
      });
    }
  }

  handleKeyDown = (e) => {
    const { keyCode } = e;
    const { state, refs, props } = this;

    // Early returns for simpler flow control
    if (!state.navigating && !this.shouldHandleNonNavigatingKeys(keyCode, state)) {
      return;
    }

    // Handle dialog states first (open/clearCache)
    if (state.open || state.clearCache) {
      this.handleDialogKeys(keyCode, state, refs);
      return;
    }

    // Handle navigating state
    if (state.navigating) {
      this.handleNavigatingKeys.call(this, keyCode, state, refs, props);
      return;
    }

    // Handle non-navigating state
    this.handleNonNavigatingKeys.call(this, keyCode, state, refs);
  }

  // Helper methods to reduce code duplication
  focusElement = (element, delay = 0) => {
    if (delay) {
      setTimeout(() => element?.focus(), delay);
    } else {
      element?.focus();
    }
  };

  setNavTimeout = (timeout = 4000) => {
    const navTimeout = setTimeout(() => {
      this.setState(prevState => ({ ...prevState, navigating: false }));
    }, timeout);
    this.setState(prevState => ({ ...prevState, navigating: true, navTimeout }));
  };

  clearNavTimeout = (state) => {
    clearTimeout(state.navTimeout);
  };

  shouldHandleNonNavigatingKeys = (keyCode, state) => {
    const movementKeys = [LEFT, RIGHT, UP, DOWN];
    const actionKeys = [BACK, ENTER];
    
    return movementKeys.includes(keyCode) || actionKeys.includes(keyCode) || 
           state.open || state.clearCache || state.openMenu;
  }

  // Handle dialog-specific keys (open/clearCache modals)
  handleDialogKeys = (keyCode, state, refs) => {
    switch (keyCode) {
      case ENTER:
        if (state.selectedBtn === 'No') {
          this.setState({ [state.open ? 'open' : 'clearCache']: false });
          this.focusElement(refs.mainDiv, 700);
        } else if (state.selectedBtn === 'Yes') {
          if (state.open) {
            window.open('', '_self').close();
          } else {
            this.removeAllDownloads();
          }
        }
        break;
      
      case LEFT:
        this.setState({ selectedBtn: 'No' });
        break;
      
      case RIGHT:
        this.setState({ selectedBtn: 'Yes' });
        break;
    }
  }

  // Handle keys when in navigating state
  handleNavigatingKeys = (keyCode, state, refs, props) => {
    switch (keyCode) {
      case ENTER:
        this.handleNavigatingEnter.call(this, state, refs);
        break;

      case LEFT:
      case RIGHT:
        this.handleNavigatingMovement.call(this, keyCode, state);
        break;

      case UP:
        this.handleNavigatingUp.call(this, state, refs, props);
        break;

      case BACK:
        this.setState({ open: !state.open });
        this.focusElement(refs.no, 200);
        break;
    }
  }

  handleNavigatingEnter = (state, refs) => {
    const actions = {
      account: () => this.goToPage('/Account'),
      upgrade: () => {
        localStorage.setItem('playlistID', this.activePlaylistId);
        this.goToPage('/Pair');
      }
    };

    const action = actions[state.selectedButton];
    if (action) {
      action();
    } else {
      this.setState(prevState => ({ 
        ...prevState, 
        navigating: false, 
        navTimeout: null 
      }));
    }
  }

  handleNavigatingMovement = (keyCode, state) => {
    this.clearNavTimeout(state);
    
    if (!state.activeComponent) {
      const handler = keyCode === LEFT ? () => this.navigate('prev') : () => this.navigate('next');
      handler();

      clearTimeout(this.navigationTimeout);
      this.setState({ navigation: true });
      this.navigationTimeout = setTimeout(() => {
        this.setState({ navigation: false });
      }, 3000);
    }
  }

  handleNavigatingUp = (state, refs, props) => {
    if (!state.open && !state.navigating) {
      this.clearNavTimeout(state);

      const navTimeout = setTimeout(() => {
        this.setState(prevState => ({ ...prevState, navigating: false }));
      }, 400000);

      const buttonConfig = props.hasSubscription 
        ? { selectedButton: 'account', ref: refs.accountButton }
        : { selectedButton: 'upgrade', ref: refs.upgrade };

      this.setState(prevState => ({ 
        ...prevState, 
        selectedButton: buttonConfig.selectedButton, 
        navTimeout 
      }));

      this.focusElement(buttonConfig.ref, 300);
    }
  }

  // Handle keys when not in navigating state
  handleNonNavigatingKeys = (keyCode, state, refs) => {
    const isMovementKey = [LEFT, RIGHT, UP].includes(keyCode);
    const canHandleMovement = !state.activeComponent && !state.openAccount && !state.openSettings;

    if (isMovementKey && canHandleMovement) {
      this.handleNonNavigatingMovement.call(this, keyCode, state);
    } else {
      this.handleNonNavigatingActions.call(this, keyCode, state, refs);
    }
  }

  handleNonNavigatingMovement = (keyCode, state) => {
    const menuHandlers = {
      [UP]: () => {
        if (state.hideCollection && !state.activeComponent && !state.openMenu) {
          this.setState({ openMenu: true });
        } else if (state.openMenu) {
          this.setState({ openMenu: false });
        }
      },

      [LEFT]: () => {
        if (state.openMenu && ['settings', 'account'].includes(state.selectedMenu)) {
          this.setState({ selectedMenu: 'account' });
        } else if (!state.mismatchPopup) {
          this.clearNavTimeout(state);
          this.setNavTimeout();
        }
      },

      [RIGHT]: () => {
        if (state.openMenu && ['account', 'settings'].includes(state.selectedMenu)) {
          this.setState({ selectedMenu: 'settings' });
        } else if (!state.mismatchPopup) {
          this.clearNavTimeout(state);
          this.setNavTimeout();
        }
      }
    };
    const handler = menuHandlers[keyCode];
    if (handler) {
      handler();
    }
  }

  handleNonNavigatingActions = (keyCode, state, refs) => {
    switch (keyCode) {
      case DOWN:
        if (!state.openSettings) {
          this.handleDownKey.call(this, state, refs);
        }
        break;
      
      case BACK:
        this.handleBackKey.call(this, state, refs);
        break;
      
      case ENTER:
        this.handleEnterKey.call(this, state, refs);
        break;
      
      case UP:
        if (state.hideCollection) {
          this.setState({ activeComponent: false });
        }
        break;
    }
  }

  handleDownKey = (state, refs) => {
    if (!state.open && !state.openMenu) {
      if (!state.activeComponent) {
        this.setState(() => ({ 
          activeComponent: true, 
          hideCollection: false, 
          openPlaylist: true 
        }));
        this.focusElement(refs.playlistChild?.refs?.carousel, 300);
      }
    } else if (state.openMenu) {
      this.setState({ openMenu: false });
    }
  }

  handleBackKey = (state, refs) => {
    if (state.openPlaylist) {
      this.setState({ openPlaylist: false });
    } else if (state.openMenu) {
      this.setState({ openMenu: false });
    } else if (state.mismatchPopup) {
      this.setState({ mismatchPopup: false });
    } else {
      setTimeout(() => {
        this.setState({ open: !state.open });
        this.focusElement(refs.no);
      }, 700);
    }
  }

  handleEnterKey = (state, refs) => {
    if (state.open) {
      if (state.selectedBtn === 'No') {
        this.setState({ open: false });
        this.focusElement(refs.mainDiv, 700);
      } else if (state.selectedBtn === 'Yes') {
        window.open('', '_self').close();
      }
    } else if (state.clearCache) {
      if (state.selectedBtn === 'No') {
        this.setState({ clearCache: false });
        this.focusElement(refs.mainDiv, 700);
      } else if (state.selectedBtn === 'Yes') {
        this.removeAllDownloads();
      }
    } else if (state.openMenu) {
      const menuActions = {
        account: () => this.setState({ openAccount: true }),
        settings: () => this.setState({ openSettings: true })
      };

      const action = menuActions[state.selectedMenu];
      if (action) action();
    }
  }

  goToPage = (pageLink) => {
    const { navigate } = this.props;
    navigate(pageLink);
  };

  removeAllDownloads() {
    const that = this;
    var successCb = function (cbObject) {
      that.setState({ clearCache: false });
      that.goToPage('/');
    };

    var failureCb = function (cbObject) {
      var errorCode = cbObject.errorCode;
      var errorText = cbObject.errorText;
    };

    var options = {
      device: 'internal', // This will remove all the files in the local storage.
    };

    var storage = new Storage();
    storage.removeAll(successCb, failureCb, options);
  }

  handleConnectionChange(event) {
    if (event.type == 'offline') {
      fireAnalytics('Network', 'Connection Offline');
      clearInterval(this.artworkIntervalTime);
      clearInterval(this.fetchMobilePlaylistInterval);
      this.showArtworkError('No Internet Connection');
    }
    if (event.type == 'online') {
      fireAnalytics('Network', 'Connection Online');
      if (this.props.hasSubscription) {
        this.setArtworkInterval(this.artworkInterval);
        this.fetchMobilePlaylistInterval = setInterval(() => this.FetchFromMobile(), 5000);
      } else {
        this.setArtworkInterval(this.artworkInterval);
      }
      this.showArtworkError('Connection Online');
    }
  }

  hideCollections() {
    this.setState(() => ({ hideCollection: true }));
  }

  setArtworkInterval(interval) {
    if (this.props.setting.switchArtwork) {
      if (interval === 0) {
        this.artworkInterval = interval;
        clearInterval(this.artworkIntervalTime);
      } else {
        clearInterval(this.artworkIntervalTime);
        this.artworkInterval = interval;
        this.artworkIntervalTime = setInterval(() => {
          this.k = 1;
          setTimeout(() => {
            this.navigate('next');
          }, 800);
        }, this.artworkInterval);
      }
    }
  }

  // Main method - now much cleaner and focused
  async FetchFromMobile() {
    try {
      if (!this.props.hasSubscription) {
        return;
      }
    
      const status = await this.props.fetchMobileStatus(this.props.device.data.uid);
      
      // Handle fetch errors first
      if (!this.handleFetchErrors(status)) {
        return;
      }
    
      // Initialize state on first run
      this.initializeStateIfNeeded(status.payload);
    
      // Update device settings
      this.updateDeviceSettings(status.payload);
    
      // Handle reboot if needed
      if (status.payload?.reboot) {
        await this.handleDeviceReboot();
        return;
      }
    
      // Handle queue updates
      await this.handleQueueUpdates(status);
    
      // Handle user ID changes
      this.handleUserIdChanges(status.payload);
    
    } catch (err) {
      console.error('FetchFromMobile error:', err);
    }
  }
  
  // Handle fetch status errors
  handleFetchErrors = (status) => {
    if (status.type === FETCH_MOBILE_STATUS_FAILURE) {
      if (status.errors === 'Device Unregistered') {
        this.cancelDownloadIfInProgress();
        this.goToPage('/');
        return false;
      }
    }
    return true;
  };
  
  // Cancel download if in progress
  cancelDownloadIfInProgress = () => {
    if (this.download?.isDownloadProgress) {
      this.download.cancelDownload(key => {
        console.log('Cancel Download on Unregistered', key);
      });
    }
  };
  
  // Initialize state values on first run
  initializeStateIfNeeded = (payload) => {
    const stateUpdates = {};
    
    if (this.state.lastMobileUpdate === null && payload?.queueUpdatedAt) {
      stateUpdates.lastMobileUpdate = payload.queueUpdatedAt;
    }
    
    if (this.state.userId === null && payload?.userId) {
      stateUpdates.userId = payload.userId;
    }
    
    if (Object.keys(stateUpdates).length > 0) {
      this.setState(stateUpdates);
    }
  };
  
  // Update device settings based on payload
  updateDeviceSettings = (payload) => {
    const settingsMap = [
      {
        condition: this.artworkInterval !== payload.interval,
        action: () => this.setArtworkInterval(payload.interval)
      },
      {
        condition: this.state.qr !== payload.qr,
        action: () => {
          this.setState({ qr: payload.qr });
          this.props.updateQR(payload.qr);
        }
      },
      {
        condition: payload.details !== undefined,
        action: () => {
          this.setState({ hideDetails: payload.details });
          this.props.updateShowArtDetails(payload.details);
        }
      },
      {
        condition: this.state.quality !== payload.highQuality,
        action: () => {
          this.setState({ quality: payload.highQuality });
          this.props.updateQuality(payload.highQuality);
        }
      },
      {
        condition: this.state.logo !== payload.logo,
        action: () => {
          this.setState({ logo: payload.logo });
          this.props.updateShowLogo(payload.logo);
        }
      },
      {
        condition: this.state.matchContent !== payload.matchContent,
        action: () => {
          this.setState({ matchContent: payload.matchContent });
          this.props.updateMatchContent(payload.matchContent);
        }
      },
      {
        condition: this.state.mute !== payload.mute,
        action: () => {
          this.setState({ mute: payload.mute });
          this.props.updateMute(payload.mute);
        }
      },
      {
        condition: this.state.fillScreen !== payload.fillScreen,
        action: () => {
          this.setState({ fillScreen: payload.fillScreen });
          // Note: Fixed bug - was using payload.mute instead of payload.fillScreen
          this.props.updateFillScreen(payload.fillScreen);
        }
      }
    ];
  
    // Execute all applicable setting updates
    settingsMap.forEach(setting => {
      if (setting.condition) {
        setting.action();
      }
    });
  };
  
  // Handle device reboot
  handleDeviceReboot = async () => {
    try {
      const response = await this.props.updateDevice(
        this.props.device.data.id, 
        'reboot', 
        false
      );
      
      if (response.success) {
        location.reload();
      } else {
        this.showError('Unable to Save Settings');
      }
    } catch (err) {
      this.showError('Unable to Save Settings');
    }
  };
  
  // Handle queue updates
  handleQueueUpdates = async (status) => {
    const payload = status.payload;
    const shouldUpdateQueue = (
      this.state.lastMobileUpdate !== payload?.queueUpdatedAt && 
      payload?.playingCollection !== null
    );
  
    if (!shouldUpdateQueue) {
      return;
    }
  
    const result = await this.props.fetchMobileQueue(this.props.device.data.uid);
    
    // Handle queue fetch errors
    if (!this.handleQueueFetchErrors(result)) {
      return;
    }
  
    if (result.type === 'FETCH_MOBILE_QUEUE_SUCCESS') {
      await this.processQueueSuccess(result, payload);
    }
  };
  
  // Handle queue fetch errors
  handleQueueFetchErrors = (result) => {
    if (result.errors === 'Error') {
      this.navigateToError();
      return false;
    }
    
    if (result.errors === 'Device Unregistered') {
      this.goToPage('/');
      return false;
    }
    
    return true;
  };
  
  // Process successful queue fetch
  processQueueSuccess = async (result, payload) => {
    this.setState({ lastMobileUpdate: payload?.queueUpdatedAt });
  
    // Check user ID mismatch
    if (this.props.app.mobileId.localeCompare(payload.userId) !== 0) {
      this.goToPage('/');
      return;
    }
  
    // Validate artwork
    if (!this.validateArtwork(result.payload.collection.artwork)) {
      return;
    }
  
    // Update playlist
    this.updatePlaylistFromQueue(result);
  
    // Fetch active playlist
    await this.fetchActivePlaylist(result.payload.collection.id);
  };
  
  // Validate artwork data
  validateArtwork = (artwork) => {
    if (!artwork || artwork.length <= 0) {
      this.showArtworkError('Unable to play the Selected Artwork.');
      return false;
    }
    return true;
  };
  
  // Update playlist from queue data
  updatePlaylistFromQueue = (result) => {
    console.log("Playlist received from Mobile", result.payload.collection.artwork);

    this.setState({
      artworks: this.filterByOrientation(result.payload.collection.artwork),
      current: 0,
      mismatchPopup: false,
      activeComponent: false
    });
  
    // Reset intervals and flags
    clearInterval(this.artworkIntervalTime);
    this.artworkInterval = null;
    this.updatePlaylist = false;
  };
  
  // Fetch active playlist
  fetchActivePlaylist = async (collectionId) => {
    const activePlaylist = this.props.fetchActivePlaylist(collectionId);
    
    if (activePlaylist.errors === 'Error') {
      this.navigateToError();
      return;
    }
  
    fireAnalytics('Playlist', 'Playlist Received From Mobile', collectionId);
  };
  
  // Handle user ID changes
  handleUserIdChanges = (payload) => {
    if (this.state.userId !== payload.userId) {
      location.reload();
    }
  };
  
  // Utility methods for error handling
  showError = async (message) => {
    this.errorMessage = message;
    this.setState({ errorPopup: true });
    
    await this.props.fetchDevice(this.props.app.SCAPDeviceId);
    
    setTimeout(() => {
      this.setState({ errorPopup: false });
      this.props.onClose();
    }, 3000);
  };

  async getArtworkFromPlaylist(id) {
    // Check subscription first
    if (!this.props.hasSubscription) {
      localStorage.setItem('playlistID', id);
      this.goToPage('/Pair');
      return;
    }

    try {
      this.updatePlaylist = false;

      // Fetch and validate playlist
      const activePlaylist = await this.fetchAndValidatePlaylist(id);
      if (!activePlaylist) return; // Error already handled

      // Update device playlist
      await this.updateDevicePlaylist(id, activePlaylist);

      // Track analytics
      fireAnalytics('Playlist', 'Playlist Changed', id);

    } catch (error) {
      console.error('Error in getArtworkFromPlaylist:', error);
      this.navigateToError();
    }
  }

  // Fetch playlist and handle common error cases
  async fetchAndValidatePlaylist(id) {
    const activePlaylist = await this.props.fetchActivePlaylist(id);

    if (activePlaylist.errors === 'No Artworks') {
      await this.handleNoArtworksError();
      return null;
    }

    if (activePlaylist.errors === 'Error') {
      this.navigateToError();
      return null;
    }

    return activePlaylist;
  }

  // Handle the case when playlist has no artworks
  async handleNoArtworksError() {
    this.showArtworkError('No artworks in Collection');
    await this.props.fetchActivePlaylist(this.prevPlaylistId);
  }

  // Update device with new playlist
  async updateDevicePlaylist(playlistId, activePlaylist) {
    const body = {
      playlistId,
      artworkId: activePlaylist.payload.artwork[0].id,
      deviceIds: [`${this.props.device.data.id}`],
    };

    const response = await bdReq.post(
      `/users/${this.props.device.data.userId}/devices/play`, 
      body
    );

    if (response.success) {
      this.setState({ activeComponent: false });

      // Check if response has artworks
      const artworks = response.body[0]?.queue?.artworks;
      if (!artworks || artworks.length === 0) {
        this.showArtworkError('No artworks in Collection');
      } else {
        this.updatePlaylist = true;
      }
    } else {
      throw new Error('Failed to update device playlist');
    }
  }

  // Helper to show artwork error with consistent behavior
  showArtworkError(message) {
    this.setState({ 
      artworkErrorMessage: message,
      activeComponent: false, 
      artworkError: true 
    });

    setTimeout(() => {
      this.setState({ artworkError: false });
    }, 4000);
  }

  // Helper for consistent error navigation
  navigateToError() {
    setTimeout(() => {
      this.goToPage('/error');
    }, 10);
  }

  async addIdIntoDB(id) {
    let db;
    db = await idb.openDb('playlistIdDb', 1, (db) => {
      db.createObjectStore('playlistId', { keyPath: 'id' });
    });
    let tx = db.transaction('playlistId', 'readwrite');

    try {
      await tx.objectStore('playlistId').clear();
      await tx.objectStore('playlistId').add({ id });
    } catch (err) {
      if (err.name == 'ConstraintError') {
        alert('Such book exists already');
      } else {
        throw err;
      }
    }
  }

  async setCurrent(pid) {
    this.props.homePlaylist.data.filter((data, idx) => {
      if (data.playlistId === pid) {
        this.setState({ currentPlaylist: idx });
        return;
      }
    });
  }

  async setExitApp() {
    this.setState({ activeComponent: false });
  }

  handleNavigationSetup = () => {
    clearInterval(this.artworkIntervalTime);
    clearTimeout(this.state.navTimeout);
    
    // Set artwork interval based on subscription
    const interval = this.props.hasSubscription 
      ? this.props.device.data.interval 
      : this.artworkInterval;
    this.setArtworkInterval(interval);
    
    // Set navigation timeout
    const navTimeout = setTimeout(() => {
      this.setState(prevState => ({ ...prevState, navigating: false }));
    }, 4000);

    this.isPlaylistUpdated = true;

    return navTimeout;
  };

  handleArtworkDetails = () => {
    if (!this.props.setting.showArtworkDetails) {
      setTimeout(() => {
        this.setState({ hideDetails: true });
      }, 5000);
    } else {
      this.setState({ hideDetails: false });
    }
  };

  manipulateArtworks = (direction) => {
    const artworks = this.state.artworks.slice(0);

    if (direction === 'prev') {
      artworks.unshift(artworks.pop());
    } else {
      artworks.push(artworks.shift());
    }

    return artworks;
  };

  navigate = (direction) => {
    const navTimeout = this.handleNavigationSetup();
    const artworks = this.manipulateArtworks(direction);
    
    this.setState(prevState => ({
      ...prevState,
      navTimeout,
      artworks
    }));

    this.handleArtworkDetails();
  };

  playOfflineArtworks = (artworks) => {
    this.setState({
      artworks,
      current: 0,
    });
    this.setState({ activeComponent: false });
  };

  playDownloadedArtworkOnly = (offlineArtworkList) => {
    let offlineArtworksName = [];
    for(let artwork of offlineArtworkList){
      let obj = {};
      obj.name = artwork.name.toString().split('.mp4')[0];
      offlineArtworksName.push(obj);
    }
    filterPlaylist(this.state.artworks, offlineArtworksName, false)
      .then(finalArtworksList => {
        this.playOfflineArtworks(finalArtworksList);
      });
  };

  getCurrentArtworkName() {
    const { artworks } = this.state;
    if (!artworks || artworks.length == 0) return '';

    return artworks[this.state.current].name;
  }

  getCurrentArtworkArtistName() {
    const { artworks } = this.state;
    if (!artworks || artworks.length == 0) return '';

    const { current } = this.state;
    
    if (
      artworks[current] &&
      artworks[current]._embedded &&
      artworks[current]._embedded.artist &&
      artworks[current]._embedded.artist.givenName &&
      artworks[current]._embedded.artist.surname
    ) {
      return `${artworks[current]._embedded.artist.givenName} ${artworks[current]._embedded.artist.surname}`;
    } else if (
      artworks[current] &&
      artworks[current].artist &&
      artworks[current].artist.displayName
    ) {
      return `${artworks[current].artist.displayName}`;
    } else {
      return '';
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
    clearInterval(this.fetchMobilePlaylistInterval);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.selectedPlaylistId !== this.state.selectedPlaylistId && this.updatePlaylist) {
      this.isPlaylistUpdated = true;
      this.prevPlaylistId = nextProps.selectedPlaylistId;
      const artworks = this.filterByOrientation(nextProps.artworks);
      this.setState({
        artworks,
        current: 0,
        selectedPlaylistId: nextProps.selectedPlaylistId,
      });
      clearInterval(this.artworkIntervalTime);
      this.setArtworkInterval(this.props.device.data.interval);
      this.setState({ activeComponent: false });
    }
    this.hideCollections();

    if (!nextProps.setting.showArtworkDetails) {
      this.setState({
        hideDetails: true,
      });
    } else {
      this.setState({
        hideDetails: false,
      });
    }

    if(nextProps && nextProps.setting && nextProps.setting.matchContent === false){
      if(this.state.mismatchPopup){
        this.setState({ mismatchPopup: false });
        this.navigate('next');
      }
    }
  }

  handleSoundCloudButtonClick(event) {
    if (event.keyCode === 13) {
      if (this.props.soundCloud.isStreaming) {
        this.props.pauseSoundCloudStream();
      } else {
        this.props.resumeSoundCloudStream();
      }
    }
    if (event.keyCode === 39 || event.keyCode === 37) {
      this.refs.home && this.refs.home.focus();
    }
    if (event.keyCode === 40) {
      this.refs.previous && this.refs.previous.focus();
    }
  }

  handleCloseAccount() {
    this.setState({
      openAccount: false,
      openMenu: false,
    });
  }

  handleCloseSettings() {
    this.setState({
      openSettings: false,
      openMenu: false,
      closedSettings: true
    });
    this.navigate('next');
    
    this.setState({closedSettings: false})
  }

  handleUpdateDownloads(fileName) {
    if (fileName === 0) {
      this.setState({
        downloadedArtNames: [],
        currentDownloads: 0
      });
    } else {
      this.setState(prevState => {
        if (!prevState.downloadedArtNames.includes(fileName)) {
          const updatedNames = [...prevState.downloadedArtNames, fileName];
          return {
            downloadedArtNames: updatedNames,
            currentDownloads: updatedNames.length
          };
        }
        return null;
      });
    }
    console.log("Downloads counted",this.state.currentDownloads)
  }

  changeUpdatePlaylistStatus() {
    this.isPlaylistUpdated = false;
  }

  showPermanentPopup(){
    this.setState({
      mismatchPopup: true,
      artworkError: false
    });
  }

  getStyles = () => {
    const { isPortrait } = this.state;
    return {
      paddingTop:  isPortrait ? '9%' : '',
      detailsPadding: isPortrait ? '3rem 60px 2rem 30px' : '0.7rem 60px 1.7rem 30px',
      detailsFontSize: isPortrait ? '1.2vh' : '2.8vh',
      detailsMarginBottom: isPortrait ? '2.4rem' : '1.4rem',
      mismatchBottom: isPortrait ? '40%' : '30%',
      mismatchLeft: isPortrait ? '15%' : '32%',
      mismatchWidth: isPortrait ? '70%' : '35%',
      mismatchHeight: isPortrait ? '24%' : '35%'
    };
  };

  handleResize = () => {
    this.setState({ isPortrait: window.innerWidth <= window.innerHeight })
    this.setState({ styles: this.getStyles() });
  };

  render() {
    const { current, artworks, lastMobileUpdate, currentDownloads, navigation, styles, closedSettings, isPortrait } = this.state;
    const slideWidth = 100;
    let left = -current * slideWidth - 100;
    const slides = artworks.map((item, idx) => {
      left += slideWidth;
      if (idx === current) {
        return (
          <div key={idx} className="freemium-full-screen-carousel__slide" style={{ left: `${left}%` }}>
            <Artwork
              isCurrent={idx == current}
              artwork={item}
              hasSubscription={this.props.hasSubscription}
              history={this.props.history}
              navigate={this.navigate}
              artworks={artworks}
              lastMobileUpdate={lastMobileUpdate}
              currentDownloads={currentDownloads}
              handleUpdateDownloads={this.handleUpdateDownloads}
              playDownloadedArtworkOnly={this.playDownloadedArtworkOnly}
              changeUpdatePlaylistStatus={this.changeUpdatePlaylistStatus}
              isPlaylistUpdated={this.isPlaylistUpdated}
              navigation={navigation}
              showPermanentPopup={() => this.showPermanentPopup()}
              closedSettings={closedSettings}
              unpaired={false}
            />
          </div>
        );
      }
    });

    return (
      <div className="fullscreenFreemiumWrapper" ref="mainDiv">
        {slides}
        {this.state.open ? (
          <div id="models" className="reg-response-modal" style={{ position: 'absolute', zIndex: '9999' }}>
            <div
              className="model"
              style={{ width: '40%', backgroundColor: 'black', color: 'white', borderRadius: '15px' }}
            >
              <img
                className="Logo2"
                src="assets/img/blackdove-logo-2020.png"
                alt=""
                style={{ width: '50%', paddingTop: '6%' }}
              />
              <h2 style={{ marginBottom: '2%' }}>Do you want to exit?</h2>
              <button
                ref="no"
                id="No"
                className='account__btns__cache'
                style={{
                  float: 'left',
                  marginLeft: '14%',
                  background : this.state.selectedBtn === 'No' ? '#910048' : ''
                }}
              >
                No
              </button>
              <button
                ref="yes"
                id="yes"
                className='account__btns__cache'
                style={{
                  float: 'right',
                  marginRight: '18%',
                  background : this.state.selectedBtn === 'Yes' ? '#910048' : ''
                }}
              >
                Yes
              </button>
            </div>
          </div>
        ) : null}
        {this.state.clearCache ? (
          <div id="models" className="reg-response-modal" style={{ position: 'absolute', zIndex: '9999' }}>
            <div
              className="model"
              style={{ width: '40%', backgroundColor: 'black', color: 'white', borderRadius: '15px' }}
            >
              <img
                className="Logo2"
                src="assets/img/blackdove-logo-2020.png"
                alt=""
                style={{ width: '50%', paddingTop: '6%' }}
              />
              <h2 style={{ marginBottom: '2%', fontSize: '2em', padding: '0 1em' }}>
                Do you want to clear device cache and reload app?
              </h2>
              <button
                ref="no"
                id="No"
                className='account__btns__cache'
                style={{
                  float: 'left',
                  marginLeft: '14%',
                  background : this.state.selectedBtn === 'No' ? '#910048' : ''
                }}
              >
                No
              </button>
              <button
                ref="yes"
                id="yes"
                className='account__btns__cache'
                style={{
                  float: 'right',
                  marginRight: '18%',
                  background : this.state.selectedBtn === 'Yes' ? '#910048' : ''
                }}
              >
                Yes
              </button>
            </div>
          </div>
        ) : null}

        {this.state.mismatchPopup ? (
          <div
            className="mismatchModel"
            style={{
              paddingTop: styles.paddingTop,
              bottom: styles.mismatchBottom,
              left: styles.mismatchLeft,
              width: styles.mismatchWidth,
              height: styles.mismatchHeight
            }}
          >
            <p>Cannot play any artwork from current playlist as device's screen orientaion and artwork's orientation mismatch.</p>
            <p>Either change 'Match Content' setting or play different playlist.</p> 
          </div>
        ) : null}

        {this.state.openMenu ? (
          <div className="topMenu">
            <button className={`topMenu__item ${this.state.selectedMenu === 'account' && 'selectedMenuItem'}`}>
              <img className="topMenu__item__icon" src="assets/img/account.svg" alt="" />
              <p className="topMenu__item__txt">Account</p>
            </button>
            <button className={`topMenu__item ${this.state.selectedMenu === 'settings' && 'selectedMenuItem'}`}>
              <img className="topMenu__item__icon" src="assets/img/settings.svg" alt="" />
              <p className="topMenu__item__txt">Settings</p>
            </button>
          </div>
        ) : null}

        {this.props.setting.showLogo && <img className="player-logo" src="assets/img/blackdove-logo-2020.png" alt="" />}
        {((this.state.qr && artworks[this.state.current]?.qrTrackableUrl) || !this.state.hideDetails) && (
          <div className="detail_container" style={{ padding: '1%' }}>
            {!this.state.hideDetails && (
              <div
                className="detailsContainer"
                style={{
                  padding: styles.detailsPadding,
                  right: this.state.qr && artworks[this.state.current]?.qrTrackableUrl ? '4%' : '1%',
                }}
              >
                {/* <div> */}
                <p
                  className="h--no-spacing"
                  style={{
                    color: 'white',
                    textTransform: 'uppercase',
                    fontSize: styles.detailsFontSize,
                    fontStyle: 'normal',
                    fontWeight: '600',
                    letterSpacing: '0em',
                    textAlign: 'left',
                    lineHeight: '2rem',
                    marginBottom: styles.detailsMarginBottom,
                    whiteSpace: 'nowrap',
                  }}
                >
                  {this.getCurrentArtworkName()}
                </p>
                <p
                  className="h--normalize-weight"
                  style={{
                    color: 'white',
                    fontSize: styles.detailsFontSize,
                    marginBottom: '0.2rem',
                    whiteSpace: 'nowrap',
                  }}
                >
                  {this.getCurrentArtworkArtistName()}
                </p>
                {/* </div> */}
              </div>
            )}

            {(artworks[this.state.current]?.forceQr || this.state.qr) && artworks[this.state.current]?.qrTrackableUrl && (
              <div className="QRCodeF">
                <QRCodeSVG
                  value={artworks[this.state.current].qrTrackableUrl}
                  size={80}
                  style={{
                    border: '6px solid white',
                    borderRadius: '12px',
                  }}
                />
              </div>
            )}
          </div>
        )}

        {this.state.navigating && (
          <div className="fullscreenNavOverlay">
            <div
              onClick={() => {
                this.navigate('prev');
              }}
              className="btn btn--circle navLeft"
            >
              <span tabIndex="2" ref="previous" className="ion-ios-arrow-back btn--arrow" />
            </div>
            <div>
              <p
                className="h--no-spacing"
                style={{
                  color: 'white',
                  textTransform: 'uppercase',
                  fontSize: styles.detailsFontSize,
                  fontStyle: 'normal',
                  fontWeight: '600',
                  letterSpacing: '0em',
                  textAlign: 'left',
                  lineHeight: '3rem',
                  marginBottom: styles.detailsMarginBottom,
                }}
              >
                {this.getCurrentArtworkName()}
              </p>
              <p
                className="h--normalize-weight"
                style={{
                  color: 'white',
                  fontSize: styles.detailsFontSize,
                  marginBottom: 0,
                  textAlign: 'center',
                }}
              >
                {this.getCurrentArtworkArtistName()}
              </p>
            </div>
            <div
              onClick={() => {
                this.navigate('next');
                this.k = 1;
              }}
              className="btn btn--circle navRight"
            >
              <span ref="next" tabIndex="3" className="ion-ios-arrow-forward btn--arrow" />
            </div>
          </div>
        )}

        <div className="artworkError" style={!this.state.artworkError ? { opacity: '0' } : { opacity: '1' }}>
          {this.state.artworkErrorMessage}
        </div>
        <div className="userAgent" id="userAgent"></div>
        <div className="deviceDetails" id="deviceDetails"></div>
        {this.state.activeComponent ? (
          <div className={`PlaylistSelector ${isPortrait ? 'PlaylistSelector_Rotated' : ''}`} style={this.state.activeComponent ? { bottom: isPortrait ? '32%' : '22%' } : { bottom: '-36%' }}>
            <SelectedPlaylistCarousel
              ref="playlistChild"
              playlist={this.props.homePlaylist.data}
              myPlaylist={this.props.myPlaylist}
              currentPlaylist={this.state.currentPlaylist}
              subscription={this.props.hasSubscription}
              history={this.props.history}
              dispatch={this.props.dispatch}
              getArtworkFromPlaylist={(pid) => this.getArtworkFromPlaylist(pid)}
              setCurrent={(pid) => this.setCurrent(pid)}
              onExitApp={() => this.setExitApp()}
              hideCollections={this.hideCollections}
            />
          </div>
        ) : null}

        {this.state.openAccount ? (
          <Account
            onClose={() => this.handleCloseAccount()}
            history={this.props.history}
            artworks={this.props.artworks}
            currentDownloads={this.state.currentDownloads}
          />
        ) : null}

        {this.state.openSettings ? <Settings onClose={() => this.handleCloseSettings()} /> : null}

        <SoundCloudPlayer />
      </div>
    );
  }
}
const mapDispatchToProps = (dispatch) => ({
  fetchActivePlaylist: (targetPlaylistId) => dispatch(fetchActivePlaylist(targetPlaylistId)),
  fetchMobileQueue: (deviceId) => dispatch(fetchMobileQueue(deviceId)),
  fetchMobileStatus: (deviceId) => dispatch(fetchMobileStatus(deviceId)),
  pauseSoundCloudStream: () => dispatch(pauseSoundCloudStream()),
  resumeSoundCloudStream: () => dispatch(resumeSoundCloudStream()),
  updateMute: (val) => dispatch(setMute(val)),
  updateShowLogo: (val) => dispatch(setShowLogo(val)),
  updateMatchContent: (val) => dispatch(setMatchContent(val)),
  updateShowArtDetails: (val) => dispatch(setShowArtworkDetails(val)),
  updateQR: (val) => dispatch(setQR(val)),
  updateSwitchArtwork: (val) => dispatch(setSwitchArtwork(val)),
  updateQuality: (val) => dispatch(set4kQuality(val)),
  updateFillScreen: (val) => dispatch(setFillScreen(val)),
  updateRandomise: (val) => dispatch(setRandomise(val)),
});

export default connect((state) => {
  const { homePlaylist, userPlaylists, myPlaylist, device, mobileQueue, soundCloud, app, setting } = state;
  return {
    app,
    userPlaylists,
    homePlaylist,
    myPlaylist,
    device,
    mobileQueue,
    soundCloud,
    setting,
  };
}, mapDispatchToProps)(withNavigate(FreemiumCarousel));
